import { useMemo } from "react";
import { useMcpPrompts } from "../../../hooks/use-mcp-prompts";
import { humanizePromptName } from "../format";
import type { Command, CommandContext } from "../types";

/**
 * Prompt commands (S3.11) — the Kuvio differentiator. Every MCP prompt the
 * server advertises via `prompts/list` becomes a one-keystroke command. Picking
 * one hands off to {@link CommandContext.runPrompt}, which collects required
 * args then composes + displays the prompt. The palette grows automatically as
 * new prompts ship — no chrome change.
 */
export function usePromptCommands(ctx: CommandContext): Command[] {
  const { runPrompt } = ctx;
  const prompts = useMcpPrompts();

  return useMemo(() => {
    return (prompts.data ?? []).map<Command>((p) => ({
      id: `prompt:${p.name}`,
      label: humanizePromptName(p.name),
      icon: "wand",
      kind: "prompt",
      subtitle: p.description,
      keywords: ["prompt", "run", p.name],
      execute: () => runPrompt(p),
    }));
  }, [prompts.data, runPrompt]);
}
